import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [projects, setProjects] = useState([]);
  const [projectId, setProjectId] = useState(localStorage.getItem("griyapro_project") || "");

  useEffect(() => {
    if (user) {
      api.get("/locations/public").then((r) => {
        setProjects(r.data);
        const stored = localStorage.getItem("griyapro_project");
        if (stored && !r.data.some((p) => p.id === stored)) {
          setProjectId("");
          localStorage.removeItem("griyapro_project");
        }
      }).catch(() => {});
    }
  }, [user]);

  const selectProject = useCallback((id) => {
    setProjectId(id);
    if (id) localStorage.setItem("griyapro_project", id);
    else localStorage.removeItem("griyapro_project");
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("griyapro_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api.get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => localStorage.removeItem("griyapro_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const res = await api.post("/auth/login", { email, password });
    localStorage.setItem("griyapro_token", res.data.token);
    setUser(res.data.user);
    return res.data.user;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("griyapro_token");
    localStorage.removeItem("griyapro_project");
    setUser(null);
  }, []);

  const hasPerm = useCallback(
    (module, action) => {
      if (!user) return false;
      if (user.role === "Super Admin") return true;
      return (user.permissions?.[module] || []).includes(action);
    },
    [user]
  );

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, hasPerm, projects, projectId, selectProject }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
